import softwareEngineer from "../../assets/Certificates/software_engineer certificate-1.jpg";
import frontendReact from "../../assets/Certificates/frontend_developer_react certificate-1.jpg";
import sqlAdvanced from "../../assets/Certificates/sql_advanced certificate-1.jpg";
import softwareIntern from "../../assets/Certificates/software_engineer_intern certificate-1.jpg";
import javascriptIntermediate from "../../assets/Certificates/javascript_intermediate certificate-1.jpg";
import sqlIntermediate from "../../assets/Certificates/sql_intermediate certificate-1.jpg";
import react from "../../assets/Certificates/react_basic certificate-1.jpg";
import javascript from "../../assets/Certificates/javascript_basic certificate-1.jpg";
import css from "../../assets/Certificates/css certificate-1.jpg";
import node from "../../assets/Certificates/nodejs_basic certificate-1.jpg";
import python from "../../assets/Certificates/python_basic certificate-1.jpg";
import java from "../../assets/Certificates/java_basic certificate-1.jpg";
import csharp from "../../assets/Certificates/c_sharp_basic certificate-1.jpg";
import go from "../../assets/Certificates/golang_basic certificate-1.jpg";
import sql from "../../assets/Certificates/sql_basic certificate-1.jpg";
import problemSolving from "../../assets/Certificates/problem_solving_basic certificate-1.jpg";
import jaxLondon from "../../assets/Certificates/jax-london-2026.jpg";
import jaxLondonPdf from "../../assets/Certificates/JAX_London_2026.pdf";

export const certificates = [
  {
    id: "jax-london-2026",
    title: "JAX London 2026",
    category: "Conferences",
    level: "Attendance",
    issuer: "JAX London / devmio",
    image: jaxLondon,
    imageWidth: 1190,
    imageHeight: 1684,
    pdf: jaxLondonPdf,
  },
  { id: "software-engineer", title: "Software Engineer", category: "Roles", level: "Role certification", image: softwareEngineer },
  { id: "frontend-react", title: "Frontend Developer (React)", category: "Frontend", level: "Role certification", image: frontendReact },
  { id: "sql-advanced", title: "SQL", category: "Databases", level: "Advanced", image: sqlAdvanced },
  { id: "software-intern", title: "Software Engineer Intern", category: "Roles", level: "Role certification", image: softwareIntern },
  { id: "javascript-intermediate", title: "JavaScript", category: "Frontend", level: "Intermediate", image: javascriptIntermediate },
  { id: "sql-intermediate", title: "SQL", category: "Databases", level: "Intermediate", image: sqlIntermediate },
  { id: "react", title: "React", category: "Frontend", level: "Basic", image: react },
  { id: "javascript", title: "JavaScript", category: "Frontend", level: "Basic", image: javascript },
  { id: "css", title: "CSS", category: "Frontend", level: "Basic", image: css },
  { id: "node", title: "Node.js", category: "Backend", level: "Basic", image: node },
  { id: "python", title: "Python", category: "Backend", level: "Basic", image: python },
  { id: "java", title: "Java", category: "Backend", level: "Basic", image: java },
  { id: "csharp", title: "C#", category: "Backend", level: "Basic", image: csharp },
  { id: "go", title: "Go", category: "Backend", level: "Basic", image: go },
  { id: "sql", title: "SQL", category: "Databases", level: "Basic", image: sql },
  { id: "problem-solving", title: "Problem Solving", category: "Problem solving", level: "Basic", image: problemSolving },
].map((certificate) => ({
  issuer: "HackerRank",
  imageWidth: 3308,
  imageHeight: 2520,
  ...certificate,
}));

export const certificateName = ({ title, level }) =>
  ["Basic", "Intermediate", "Advanced"].includes(level) ? `${title} (${level})` : title;

export const categories = ["All", "Conferences", "Roles", "Frontend", "Backend", "Databases", "Problem solving"];
